<template>
  <div class="feed-goods-wrapper">
    <anchor-tab
      :tabs="tabs"
      :cur-tab-index="curTabIndex"
      @changeTab="changeTab"
    />
    <div class="good-list-wrapper" :style="{ minHeight: minHeight }">
      <div v-if="goodsList.length" class="goods-list">
        <div class="goods-list-left">
          <good-item
            v-for="(item, index) in goodsList.filter(
              (item, index) => index % 2 === 0
            )"
            :key="index"
            :good="item"
            :good-index="index * 2"
          />
        </div>
        <div class="goods-list-right">
          <good-item
            v-for="(item, index) in goodsList.filter(
              (item, index) => index % 2 === 1
            )"
            :key="index"
            :good="item"
            :good-index="2 * index + 1"
          />
        </div>
      </div>
      <empty
        v-else
        :desc="'暂无商品'"
        :type="1"
        :img="'Empty'"
        class="empty-box"
      ></empty>
    </div>
  </div>
</template>

<script>
import AnchorTab from './anchor_tab/index.vue'
import GoodItem from './goodItem/index'
import { API } from '@/api'
import Empty from '@/common/layout/empty/index'
export default {
  name: 'FeedGoods',
  components: { AnchorTab, GoodItem, Empty },
  props: {
    tabs: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      goodsList: [],
      curTabIndex: 0
    }
  },
  computed: {
    minHeight() {
      const height =
        document.documentElement.clientHeight || document.body.clientHeight
      return height - 94 + 'px'
    }
  },
  mounted() {
    if (this.tabs.data && this.tabs.data.length) {
      this.changeTab({
        curTabIndex: 0
      })
    }
  },
  methods: {
    async changeTab(data) {
      this.curTabIndex = data.curTabIndex
      const curTabData = this.tabs.data[this.curTabIndex]
      // 埋点
      const tickerInfo = curTabData.tickerInfo
      const spm = tickerInfo.click.spm
      const Trackparams = Object.assign(
        tickerInfo.click.spmJson,
        tickerInfo.data
      )
      this.$track(spm, Trackparams)
      const params = {
        page_id: curTabData.action.payload,
        size: 100,
        sku_source: 5
      }
      try {
        const res = await API.recommend.getRecommendFeed(params)
        this.goodsList = this.filterGoodsList(res.list) || []
      } catch (error) {
        console.log(error)
      }
    },
    filterGoodsList(list) {
      return list.filter(item => item.object_type === 1)
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variable.scss';
@import '@/styles/mixin.scss';
.good-list-wrapper {
  position: relative;

  overflow: hidden;

  background-color: #f2f2f2;
  .goods-list {
    position: relative;

    margin: 0.2rem 0.24rem 0 0.24rem;

    @include flex(row, space-between, flex-start, nowrap);

    &-left,
    &-right {
      @include flex(column, normal, flex-start, nowrap);
    }
  }
}
</style>
